"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UYGUNSUZLUK_BILDIRIM_SAPKALARI = exports.SOZLUK_NUSHA_GIZLEME_SAPKALARI = exports.SOZLUK_YAZMA_SAPKALARI = exports.IZIN_TALEP_SAPKALARI = exports.EKIPMAN_YUKLEME_SAPKALARI = exports.EGITIM_YUKLEME_SAPKALARI = exports.AKSIYON_DEVIR_YUKLEME_SAPKALARI = exports.TENANT_AYAR_YAZMA_SAPKALARI = exports.KIMLIK_GOSTERIM_SAPKALARI = exports.YETKINLIK_YAZMA_SAPKALARI = exports.KISI_YUKLEME_SAPKALARI = exports.KISI_YAZMA_SAPKALARI = exports.ISYERI_ARSIV_SAPKALARI = exports.ISYERI_YAZMA_SAPKALARI = exports.SIRKET_YAZMA_SAPKALARI = exports.FORM_SABLON_YAZMA_SAPKALARI = exports.FORM_DOLDURMA_SAPKALARI = exports.AKSIYON_EK_SAPKALARI = exports.KKD_NUSHA_SILME_SAPKALARI = exports.DOKUMAN_YAZMA_SAPKALARI = exports.DOKUMAN_OKUMA_SAPKALARI = exports.KKD_ZIMMET_OKUMA_SAPKALARI = exports.GOREVLENDIRME_OKUMA_SAPKALARI = exports.KKD_ZIMMET_YAZMA_SAPKALARI = exports.ACIL_DURUM_YAZMA_SAPKALARI = exports.ACIL_DURUM_OKUMA_SAPKALARI = exports.KURUL_YAZMA_SAPKALARI = exports.KURUL_OKUMA_SAPKALARI = exports.SAHA_TURU_YAZMA_SAPKALARI = exports.SAHA_TURU_OKUMA_SAPKALARI = exports.MODUL_ROLLERI_DASHBOARD = exports.YAPILANDIRMA_OKUMA_SAPKALARI = exports.KULLANICI_OKUMA_SAPKALARI = exports.SOZLUK_OKUMA_SAPKALARI = exports.YUKUMLULUK_OKUMA_SAPKALARI = exports.UYGUNSUZLUK_OKUMA_SAPKALARI = exports.RISK_OKUMA_SAPKALARI = exports.EGITIM_OKUMA_SAPKALARI = exports.FORM_OKUMA_SAPKALARI = exports.AKSIYON_OKUMA_SAPKALARI = exports.AKSIYON_ACMA_SAPKALARI = exports.EKIPMAN_YAZMA_SAPKALARI = exports.SAPKA_VERME_SAPKALARI = exports.LOKASYON_YAZMA_SAPKALARI = exports.EKIPMAN_OKUMA_SAPKALARI = exports.YUKLENICI_OKUMA_SAPKALARI = exports.CALISAN_OKUMA_SAPKALARI_TEMSILCISIZ = exports.CALISAN_OKUMA_SAPKALARI = exports.ORGANIZASYON_OKUMA_SAPKALARI = exports.IC_KULLANICI_SAPKALARI = void 0;
exports.SALT_OKUNUR_SAPKALAR = exports.PORTAL_SAPKALARI = exports.ELLE_VERILEBILEN_SAPKALAR = exports.ZINCIR_EK_BASAMAK_SAPKASI = exports.ZINCIR_VARSAYILAN_BASAMAK_SAPKASI = exports.ZINCIR_BASAMAK_SAPKALARI = exports.YUKUMLULUK_ISARET_SAPKALARI = exports.YUKUMLULUK_KUTUPHANE_GIZLEME_SAPKALARI = exports.YUKUMLULUK_KUTUPHANE_YAZMA_SAPKALARI = exports.EVRAK_PAKETI_OKUMA_SAPKALARI = exports.YUKLENICI_PAKET_ATAMA_SAPKALARI = exports.EVRAK_PAKETI_YAZMA_SAPKALARI = exports.YUKLENICI_YAZMA_SAPKALARI = void 0;
const shared_types_1 = require("@isg/shared-types");
/**
 * MODÜL OKUMA ŞAPKALARI — **MENÜ İLE SUNUCUNUN TEK ORTAK KAYNAĞI**
 * (SERTLEŞTİRME TUR 7 / M2; CLAUDE.md §2.31 · Kapsam §20.3a).
 *
 * ════════════════════════════════════════════════════════════════════════
 * NEDEN BURADA
 * ════════════════════════════════════════════════════════════════════════
 *
 * Menü satırlarının rol listesi `apps/web/src/shell/menu.ts` içinde **elle**
 * yazılıyordu; uçların listesi ise controller'ların `@RequireRole`ünde. İki
 * liste **beş kez** ayrıştı ve biri **CANLI ARIZAYDI**: *Sözlükler* satırı
 * `location_manager` + `isg_technician`e çiziliyor, ekran **403** veriyordu
 * — §2.40'ın en kötü kolu (*basılınca hata verir*). Diğer dördü ters yönde
 * sessizdi: uç izin veriyor, **menüde satır yok** (yüklenici onaycısı kendi
 * modülünü menüden göremiyordu).
 *
 * Çözüm sunucudan menü beslemek DEĞİLDİR (görünürlük bir yetki kararı değil,
 * §2.16): **liste tek yerde yaşar ve iki taraf da onu import eder.** Zaten
 * kurulu olan desen budur — `SAGLIK_OKUMA_SAPKALARI` (saglik.ts) menüde de
 * uçta da aynı sabittir; bu dosya o deseni **genelleştirir.**
 *
 * ⚠️ **MENÜ YALNIZ DARALTABİLİR, GENİŞLETEMEZ.** Bir menü satırının rol
 * kümesi buradaki sabitin **alt kümesi** olmak zorundadır; envanter testleri
 * bunu iki uçtan birden kilitler:
 *   - `apps/web/src/shell/menu.spec.ts`     → satır ⊆ sabit
 *   - `apps/api/src/authorization/menu-read-uc-envanteri.spec.ts`
 *                                           → uç metadata'sı = sabit
 *
 * ⚠️ **BU BİR YETKİ KARARI DEĞİL, BİR AYNADIR.** Buradaki bir listeyi
 * genişletmek o modülün okuma ucunu genişletmektir ve **ürün kararıdır**
 * (§20.5). Sabiti değiştiren kişi `write-role-inventory` ya da modülün kendi
 * controller spec'iyle karşılaşır.
 *
 * ⚠️ **`SAGLIK_OKUMA_SAPKALARI` BURAYA TAŞINMADI** — `saglik.ts`te kalır:
 * o liste bir menü sadeleştirmesi değil, **sağlık verisi izolasyonunun
 * sınırıdır** (§16.11/10) ve gerekçesi kendi modülünün yanında durmalıdır.
 */
/**
 * TÜM İÇ KULLANICI ŞAPKALARI — `PTW_IC_KULLANICILAR`ın gövdesi.
 *
 * ⚠️ Tanım BURAYA taşındı; `apps/api/src/ptw/ptw-permit.shared.ts` artık
 * bunu **yeniden ihraç eder** (ikinci liste yazılmaz). Yüklenici temsilcisi
 * bilinçli DIŞARIDADIR — portal ayrı kabuktur (§18.2).
 */
exports.IC_KULLANICI_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'physician',
    'ysp',
    'area_supervisor',
    'employee',
    'employee_rep',
];
/** İç kullanıcılar + izleyici — "genel GET kuralı"nın kod karşılığı. */
const IC_VE_IZLEYICI = [
    ...exports.IC_KULLANICI_SAPKALARI,
    'viewer',
];
/**
 * Şirketler + işyerleri (TEK sekme — S10 gezinti kararı): `GET companies`,
 * `GET companies/:id/workplaces`, `GET workplaces/:id/locations`.
 *
 * ✏️ **TUR 9 / K2 — OKUMA BAHÇEDEN, İŞLEM ŞAPKADAN.** Liste eskiden dört
 * şapkaydı (`holding_admin` · `company_admin` · `isg_specialist` · `viewer`)
 * ve **beş şapkayı dışlıyordu**: hekim · YSP · teknisyen · lokasyon yöneticisi
 * · alan sorumlusu. Beşi de sahada organizasyona bakmak zorunda olan
 * şapkalardı ve *"kendi işyerimi göremiyorum"* madde 182 tam buydu.
 *
 * ⚠️ **ŞAPKA LİSTESİ BİR KAPI DEĞİL, ARTIK BİR AYNADIR.** Kapsamı **bahçe**
 * belirler (`readGarden` — TUR 9 / K1 ile artık TÜRETİLEN tabanı da taşır):
 * kullanıcı yalnız bahçesindeki şirketi/işyerini görür, bahçesi boşsa hiçbir
 * şey (fail-closed DEĞİŞMEDİ). Şapka ekseninde daraltmak, kendi işyerinin
 * künyesini okumak isteyen çalışanı **sebepsiz** dışarıda bırakıyordu.
 *
 * ⚠️ **BİLİNÇLİ SONUÇ:** sıradan çalışan kendi işyerinin künyesini ve
 * çalışan listesini görür. **İŞLEM ŞAPKADA KALDI** — şirket/işyeri açma,
 * arşivleme, kişi açma, istihdam açma/kapatma ve **tam kimlik okuma**
 * (`kimlik-full`) kapıları **hiç değişmedi** (kanarya:
 * `menu-read-uc-envanteri.spec` + `person.controller.spec`).
 */
exports.ORGANIZASYON_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/**
 * `GET persons` (+ istihdam/yetkinlik listeleri) — temsilci DE okur (portal
 * personel listesi aynı uçtan beslenir, §18.2); menü onu **daraltır** çünkü
 * temsilci ana kabuğa hiç girmez.
 *
 * ✏️ **TUR 9 / K2:** organizasyon listesiyle AYNI gerekçe — kapsam bahçeden
 * gelir. Temsilci kolu korunur (portal).
 */
exports.CALISAN_OKUMA_SAPKALARI = [
    ...IC_VE_IZLEYICI,
    'contractor_rep',
];
/**
 * Çalışan okuma listesinin **TEMSİLCİSİZ** hâli — iki ucun kapısı:
 *
 *   · `GET persons/export` (TUR 6 / S8): temsilci firmasının personelini
 *     portalda GÖRÜR ama **indiremez** — ekranda maskeli duran liste dosyaya
 *     iniyordu.
 *   · `GET persons/:id/competencies`: yetkinlik **kişinin taşınabilir
 *     niteliğidir** (§2.7) ve portal yüzeyi *"kendi firmasının bugünkü
 *     personeli + kendi-firma istihdam satırları"* ile sınırlıdır (§18.2).
 *
 * ⚠️ **İKİNCİ LİSTE DEĞİLDİR — okuma listesinden TÜRETİLİR.** Elle yazılsaydı
 * tur 9'un genişlemesi (K2) buraya gelmez ve iki liste sessizce ayrışırdı;
 * `person-export.spec` ile `temsilci-uc-envanteri.spec` farkı **tam
 * eşitlikle** kilitler.
 */
exports.CALISAN_OKUMA_SAPKALARI_TEMSILCISIZ = exports.CALISAN_OKUMA_SAPKALARI.filter((rol) => rol !== 'contractor_rep');
/**
 * `GET contractors[/liste]` — ⚠️ **`location_manager` BURADADIR** ve menüde
 * yoktu: tur 6'nın K4 onaycısı (uzman + şirket/lokasyon yön.) kendi modülünü
 * menüde göremiyordu.
 */
exports.YUKLENICI_OKUMA_SAPKALARI = [
    'holding_admin',
    'viewer',
    'company_admin',
    'isg_specialist',
    'location_manager',
    'contractor_rep',
];
/**
 * `GET equipment` — ⚠️ durum geçişini YAPAN şapkalar (lokasyon yön. ·
 * teknisyen · saha sorumlusu) menüde yoktu.
 */
exports.EKIPMAN_OKUMA_SAPKALARI = [
    'holding_admin',
    'viewer',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'area_supervisor',
];
/**
 * YAZMA KAPISI SABİTLERİ (yüzey dürüstlüğü turu · ikinci oturum — madde 219;
 * Kapsam §20.3b P13).
 *
 * ⚠️ **BUNLAR YENİ YETKİ KARARI DEĞİLDİR** — uçların `@RequireRole`ünde elle
 * yazılı duran listeler buraya TAŞINDI. Sebep: bayrak ve yazamama sebebi
 * kapının adımlarından okunur (`kapiDurumu`) ve şapka adımı listeyi ekrana
 * TAŞIR; liste iki yerde yazılı kalsaydı ekran bir listeyi, uç ötekini
 * söylerdi (ekranda sabit şapka listesi — B1'in birinci bulgusu).
 * `write-role-inventory` uç metadata'sını hâlâ harfiyen karşılaştırır.
 */
/** Lokasyon düğümü aç + toplanma noktası işareti (`workplaces/:id/locations`). */
exports.LOKASYON_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/**
 * Şapka VERME / GERİ ALMA (`POST/DELETE role-assignments` — §20.5/A4). Kişi
 * kartının şapka bölümü yazamayan kullanıcıya sebebi bu sabitten yazar.
 */
exports.SAPKA_VERME_SAPKALARI = ['holding_admin'];
/** Ekipman künyesi + kontrol geçmişi (`equipment/:id` · `…/inspections`). */
exports.EKIPMAN_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
];
/**
 * Aksiyon açma/atama (`POST actions` — Kapsam §22.3/2). Olay · uygunsuzluk ·
 * risk maddesi · kurul kararı DÖF'leri AYNI kapıdan geçer; bayrakları da bu
 * sabitle başlayan adım listesinden okunur (dört kopya teke indi). İSG ekibi
 * ayrıca `uzman_aksiyon_atama` anahtarına tabidir (kapının durum adımı).
 */
exports.AKSIYON_ACMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
];
/** `GET actions` — T8 (tur 2): teknisyen kendi açtığı aksiyonun listesini görür. */
exports.AKSIYON_OKUMA_SAPKALARI = [
    'holding_admin',
    'viewer',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
];
/** `GET form-templates` — tüm iç şapkalar + izleyici; temsilci YOK (tur 6/S8). */
exports.FORM_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/** `GET trainings`. */
exports.EGITIM_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/** `GET risk-assessments` — ⚠️ **beş YAZABİLEN şapka** menüde yoktu. */
exports.RISK_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/** `GET nonconformities`. */
exports.UYGUNSUZLUK_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/** `GET obligations` — ekipman periyodu okuma listesiyle AYNI (F4·S11·B). */
exports.YUKUMLULUK_OKUMA_SAPKALARI = [
    'holding_admin',
    'viewer',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'area_supervisor',
];
/**
 * `GET lookup/:listeKodu` — ⚠️ **CANLI ARIZANIN KAYNAĞI:** menü satırı altı
 * şapkaya çiziliyordu, uç dördünü tanıyordu. Liste burada **daralır** ve
 * menü onu izler.
 */
exports.SOZLUK_OKUMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
    'viewer',
    'contractor_rep',
];
/** `GET app-users` (F4·B2 — Y1). */
exports.KULLANICI_OKUMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/** Tenant yapılandırma yüzeyi — yalnız holding yöneticisi. */
exports.YAPILANDIRMA_OKUMA_SAPKALARI = ['holding_admin'];
/**
 * `GET dashboard/options` + `GET dashboard/kpi` (TUR 12 / K11 — Kapsam §26.7).
 *
 * ⚠️ **BU SATIR MENÜDE YOKTUR ve olmayacaktır:** dashboard, *"Genel bakış"*ın
 * YERİNE geçer (menü satırı ARTMAZ). Liste yine de burada yaşar, çünkü
 * §2.31'in kuralı *"menü ile sunucunun tek ortak kaynağı"*dır ve giriş
 * sayfası da bir yüzeydir.
 *
 * ⚠️ **DARALTILAMAZ:** dashboard bir modül ekranı değil, **herkesin indiği
 * sayfadır**. Şapka listesi daraltılsaydı sıradan çalışan giriş sayfasında
 * **403** görürdü — §2.40'ın en kötü kolu, üstelik ilk saniyede.
 * Kapsamı **bahçe** belirler (tur 9 / K2): sıradan çalışan kendi işyerinin
 * oranını görür, holding yöneticisi holdingin.
 *
 * ⚠️ **Temsilci DIŞARIDA** — portal ayrı kabuktur (§18.2) ve yüklenici
 * firmasının kendi KPI'ı bu turun kararı değildir.
 */
exports.MODUL_ROLLERI_DASHBOARD = IC_VE_IZLEYICI;
/**
 * SAHA TURU / DENETİM (05.09.2026 — Kapsam §27/S6 · §20.5).
 *
 * OKUMA: `GET site-tours` (menünün ana okuma ucu) · `/:id` · `/:id/
 * observations` · `/options` · `/export` · `/:id/pdf` → tüm iç şapkalar +
 * izleyici; kapsam BAHÇEDEN (tur 9 / K2 — okuma bahçeden, işlem şapkadan).
 * Temsilci DIŞARIDA (portal ayrı kabuk).
 */
exports.SAHA_TURU_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/**
 * YAZMA (S6): tur aç · ekip · gözlem · fotoğraf · kapanış — altı şapka,
 * hedef TURUN İŞYERİ (`garden-checked`). Kapanışın asıl kapısı KİMLİKTİR
 * (yalnız lider, 403). ⚠️ Görevlendirme şartı YOK (*"iç denetçi"* → v2).
 * ⚠️ İzleyici ve temsilci bilinçli DIŞARIDA; `employee` da dışarıda —
 * saha turu bir denetim eylemidir, bildirim değil (§24/3'ün "tüm iç
 * çalışanlar" satırı UYGUNSUZLUK bildirimine aittir, buraya taşınmaz).
 */
exports.SAHA_TURU_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'area_supervisor',
];
/**
 * İSG KURULU (05.09.2026 — Kapsam §28/28.3 · §20.5).
 *
 * OKUMA: `GET committees` (menünün ana okuma ucu) · `/options` ·
 * `/gundem-secenekleri` · `/:id` · `/:id/meetings` · `/:id/meetings/export` ·
 * `GET committee-meetings/:id` · `/:id/pdf` → tüm iç şapkalar + izleyici;
 * kapsam BAHÇEDEN (tur 9 / K2). Temsilci DIŞARIDA (portal ayrı kabuk).
 */
exports.KURUL_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/**
 * YAZMA (§28.3): kurul kur/düzenle · toplantı planla/düzelt · katılım ·
 * gündem · karar · DÖF · kapanış · imzalı nüsha · "gündeme ekle" — beş şapka.
 * ⚠️ Saha sorumlusu YOK (kurul bir işyeri organıdır, alan organı değil) ·
 * izleyici ve temsilci DIŞARIDA · `employee` dışarıda: ÜYELİK YETKİ TAŞIMAZ
 * (G1 — *"herhangi bir üye çağırabilir"* cümlesi §28.1/8'de kapandı).
 */
exports.KURUL_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
];
/**
 * ACİL DURUM (06.09.2026 — Kapsam §29/E7 · §20.5).
 *
 * OKUMA: `GET emergency` (menünün ana okuma ucu — işyeri eksenli liste) ·
 * `GET emergency/workplaces/:workplaceId` · belge indirme · iletişim PDF →
 * tüm iç şapkalar + izleyici; kapsam BAHÇEDEN (tur 9 / K2). Temsilci
 * DIŞARIDA (portal ayrı kabuk). Ekipler görevlendirme okumasıdır, ekipman
 * envanter okumasıdır — ikisi de kendi listesinden değil bu listeden okunur
 * çünkü acil durum sayfası bir OKUMA YÜZEYİDİR (dashboard K6 deseni).
 */
exports.ACIL_DURUM_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/**
 * YAZMA (E7): kontrollü belge yükle/sil · acil iletişim satırı — beş şapka,
 * hedef İŞYERİ. ✏️ **Tatbikat açma bu listenin DEĞİL saha turu yazma
 * kapısının işidir** (`SAHA_TURU_YAZMA_SAPKALARI` — saha sorumlusu dahil;
 * yüzey dürüstlüğü B1/4: bayrak buraya bakıyordu ve sorumlu düğmeyi
 * göremiyordu). Hedef İŞYERİ
 * (`garden-checked`). ⚠️ Saha sorumlusu YOK (plan ve iletişim listesi bir
 * işyeri belgesidir, alan belgesi değil) · izleyici ve temsilci DIŞARIDA ·
 * `employee` dışarıda: ekip üyeliği yetki taşımaz (G1). Toplanma noktası
 * işareti lokasyon ağacının yazma kapısındadır (holding · şirket yön.).
 */
exports.ACIL_DURUM_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
];
/**
 * KKD ZİMMETİ (07.09.2026 — Kapsam §30/Z5 · §20.5).
 *
 * YAZMA: teslim kaydı açma · iptal · imzalı nüsha yükleme/silme — **YALNIZ
 * İSG UZMANI** (ürün sahibi kararı Z5: sahada teslimi yapan uzmandır).
 * ⚠️ Holding ve şirket yöneticisi bilinçli DIŞARIDA — genişletme ürün
 * kararıdır (§20.5), buraya şapka eklemek o kararı vermektir. Bahçe KİŞİ
 * ekseninden (`assertPersonWriteAllowed` — yetkinlik/görevlendirme ucuyla
 * aynı kapı). Kalem ekleme sözlük ucundan, matbu metin yapılandırma
 * ucundan — bu liste onları KAPSAMAZ.
 */
exports.KKD_ZIMMET_YAZMA_SAPKALARI = ['isg_specialist'];
/**
 * GÖREVLENDİRME OKUMA (Kapsam §25 · §20.5): kişi kartı bölümü · uygunluk
 * paneli · tür bazlı liste (`GET designations` — Çalışanlar > Görevlendirmeler
 * sekmesi). Liste yetkinlik OKUMA ucunun aynısıdır (tur 4½ kararı).
 *
 * ✏️ MADDE 287 (yetki paketi artçısı, 29.09.2026): liste DEĞİŞMEDİ, ADI KONDU.
 * Dört okuma ucunda elle yazılıydı; sekmenin görünürlüğü
 * (`yuzeyler.gorevlendirmeListesi`) artık AYNI sabitten türer — sekmeyi gören
 * şapka ucu da okur (persona yoklaması altı şapkada sekmenin çizilip ana
 * ucunun 403 verdiğini ölçtü). ⚠️ Genişletmek ürün kararıdır.
 *
 * ✏️ MADDE 292 (yetki artçısı 2 — ürün sahibi kararı A, 30.09.2026; Kapsam
 * §14 YP-3 · §20.5): **LOKASYON YÖNETİCİSİ ve İSG TEKNİKERİ EKLENDİ.** İkisi
 * zorunlu görevlendirme SAYISINI zaten görüyordu (S4-4 · YP-1); *"İlk yardımcı:
 * 2 eksik"* gören kişi mevcut ilk yardımcıların KİM olduğunu da bilmelidir
 * (acil durum gerçeği) — sayı ile liste tutarlı olur. ⚠️ **YALNIZ OKUMA:**
 * yazma listesi (`GOREVLENDIRME_YAZMA_SAPKALARI`) DEĞİŞMEDİ. Bahçe süzgeci
 * aynen (liste `gardenIsverenKosulu`, kişi ucu `assertPersonReadAllowed`).
 * Dört uç aynı sabiti okur — liste · kişi kartı bölümü · bölümün kapısı ·
 * uygunluk paneli; panel bu iki şapkaya yeni bir veri alanı AÇMAZ (yetkinliği
 * ve kanaati zaten okurlar, görevlendirme bu kararla açıldı). Alan sorumlusu ·
 * hekim · YSP · çalışan listede YOKTUR: sekme ve kişi kartı bölümleri onlarda
 * çizilmez, çağrılmaz (`ikincilOkuma.gorevlendirme`).
 */
exports.GOREVLENDIRME_OKUMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
    'location_manager',
    'isg_technician',
    'viewer',
];
/**
 * OKUMA: kişi kartı bölümü · zimmet formu PDF · nüsha indirme · Çalışanlar
 * sekmesi listesi → kişi kartının okuma listesinin **temsilcisiz** hâli
 * (yüklenici işçisine KKD'yi kendi firması verir; portal bu veriyi
 * taşımaz). ⚠️ Menü satırı YOK (sekme — IA §4.1); liste yine de burada yaşar
 * (§2.31 — menü ile sunucunun tek ortak kaynağı).
 */
exports.KKD_ZIMMET_OKUMA_SAPKALARI = exports.CALISAN_OKUMA_SAPKALARI_TEMSILCISIZ;
/**
 * DOKÜMAN YÖNETİMİ — V1 SADE RAF (07.09.2026 — Kapsam §31/K5 · §20.5).
 *
 * OKUMA: `GET documents` (menünün ana okuma ucu — sekmeli raf listesi) ·
 * `GET documents/:id/download` → tüm iç şapkalar + izleyici; kapsam
 * BAHÇEDEN (tur 9 / K2). Temsilci DIŞARIDA (portal ayrı kabuk).
 */
exports.DOKUMAN_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/**
 * YAZMA (K5): raf belgesi yükle / sil — *"uzman + yönetici üçlüsü"*
 * (tutanak cümlesi harfiyen), hedef İŞYERİ (`garden-checked`, dal kapsamı
 * yetmez — acil durum E7 deseni). ⚠️ İSG teknisyeni ve saha sorumlusu
 * bilinçli DIŞARIDA — genişletme ürün kararıdır (§20.5). Acil durum
 * belgesi bu listeyle YAZILMAZ (raf uçları tekil tipi 422'ler — yazma
 * yüzeyi acil durum sayfasıdır).
 */
exports.DOKUMAN_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
];
// ═══════════════════════════════════════════════════════════════════════════
// YÜZEY DÜRÜSTLÜĞÜ ARTÇISI (12.09.2026 — madde 225 · 227; Kapsam §20.3b
// P13-b/P13-c · §20.5). Aşağıdaki sabitler İKİ okuyucuya birden hizmet eder:
// ilgili yazma ucunun `@RequireRole`ü ve liste kapıları ucu (`GET kapilar` /
// ek silme aileleri). Ekran hiçbir şapka dizgesi yazmaz — bu sabitleri
// SUNUCUDAN gelen `KapiDurumu` üzerinden okur (`yazma-kapisi-envanteri.spec`
// birikmiş listeyi boş tutar).
// ═══════════════════════════════════════════════════════════════════════════
/**
 * KKD imzalı nüsha SİLME (madde 227 — Kapsam §20.5 tek matris satırı): Z5'in
 * *"holding yön. yazmaz"* kuralına TEK istisna — holding yöneticisi yalnız
 * nüsha SİLER (teslim kaydı · iptal · yükleme aynen uzmanda).
 */
exports.KKD_NUSHA_SILME_SAPKALARI = [
    'isg_specialist',
    'holding_admin',
];
/** Aksiyon kanıt eki yükle/sil (§22.4/3-4) — iç şapkaların tamamı, izleyici ve temsilci dışarıda. */
exports.AKSIYON_EK_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'physician',
    'ysp',
    'area_supervisor',
    'employee',
    'employee_rep',
];
/** Form DOLDURMA + form eki (Kapsam §22.5/6) — bahçesi olan yetkili şapkalar. */
exports.FORM_DOLDURMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'area_supervisor',
];
/** Form ŞABLONU yazma (madde 56 — §20.5): guard listesi; asıl kapı kapsam yüklemidir. */
exports.FORM_SABLON_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
];
// ── Liste düzeyi kapılar (`GET kapilar` — P13-b) ────────────────────────────
/** Şirket CRUD — §20.5/A4. */
exports.SIRKET_YAZMA_SAPKALARI = ['holding_admin'];
/** İşyeri açma — holding + şirket yön. (kendi bahçesi). */
exports.ISYERI_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/** İşyeri arşivleme / geri açma — §20.5/A3. */
exports.ISYERI_ARSIV_SAPKALARI = ['holding_admin'];
/** Kişi açma + künye/istihdam yazma (§20.5/A1 · K11). */
exports.KISI_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/** Toplu personel aktarma (`POST import/persons` — §20.5 S9 satırı + temsilci). */
exports.KISI_YUKLEME_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'contractor_rep',
];
/** Yetkinlik yazma (`POST persons/:id/competencies`). */
exports.YETKINLIK_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
];
/** Tam kimlik gösterimi (`kimlik-full` — madde 37): izleyici bilinçli dışarıda. */
exports.KIMLIK_GOSTERIM_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/** Tenant ayarı yazma (`PUT tenant-settings/:anahtar`). */
exports.TENANT_AYAR_YAZMA_SAPKALARI = ['holding_admin'];
/** Sistem öncesi aksiyon kayıtlarını yükleme (A1 devir — yalnız holding yön.). */
exports.AKSIYON_DEVIR_YUKLEME_SAPKALARI = [
    'holding_admin',
];
/** Eğitim toplu aktarma (Y4 — yalnız holding yön.). */
exports.EGITIM_YUKLEME_SAPKALARI = ['holding_admin'];
/** Ekipman toplu aktarma (yalnız holding yön.). */
exports.EKIPMAN_YUKLEME_SAPKALARI = ['holding_admin'];
/** PTW talep açma — tüm iç kullanıcılar (şapka gerektirmez, bahçe denetimli). */
exports.IZIN_TALEP_SAPKALARI = exports.IC_KULLANICI_SAPKALARI;
/** Sözlük kalemi yazma (`POST/PATCH/DELETE lookup`) — §19/10. */
exports.SOZLUK_YAZMA_SAPKALARI = [
    'holding_admin',
    'isg_specialist',
];
/** Kütüphane nüshasını gizleme — yalnız holding yön. (§19/9). */
exports.SOZLUK_NUSHA_GIZLEME_SAPKALARI = ['holding_admin'];
/** Uygunsuzluk bildirimi (`POST nonconformities`) — iç kullanıcıların tamamı. */
exports.UYGUNSUZLUK_BILDIRIM_SAPKALARI = exports.IC_KULLANICI_SAPKALARI;
/** Yüklenici firma açma (`POST contractors`). */
exports.YUKLENICI_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/**
 * Yüklenici evrak paketi TANIMLAMA (`POST · PATCH · DELETE contractor-document-packages`;
 * K-102j — 17.09.2026): yalnız holding yön. (onay zinciri emsali — hangi
 * belgenin isteneceği kurumsal karar).
 */
exports.EVRAK_PAKETI_YAZMA_SAPKALARI = ['holding_admin'];
/**
 * Yükleniciye paket ATAMA + özel ek (K-102j): holding + şirket yön. — künye
 * yazma listesiyle aynı. İSG uzmanı EKLENMEDİ (evrak onaylar, beklentiyi
 * belirlemez).
 */
exports.YUKLENICI_PAKET_ATAMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
];
/** Evrak paketi listesi (`GET contractor-document-packages`) — yüklenici okuma, TEMSİLCİ HARİÇ. */
exports.EVRAK_PAKETI_OKUMA_SAPKALARI = [
    'holding_admin',
    'viewer',
    'company_admin',
    'isg_specialist',
    'location_manager',
];
/** Yükümlülük kütüphanesi kural/kalem yazma (`POST/PATCH obligations`). */
exports.YUKUMLULUK_KUTUPHANE_YAZMA_SAPKALARI = [
    'holding_admin',
    'isg_specialist',
];
/** Kütüphane kalemini gizleme (`PATCH obligations/:id/gizli`). */
exports.YUKUMLULUK_KUTUPHANE_GIZLEME_SAPKALARI = [
    'holding_admin',
];
/** İşyeri yükümlülük işareti / mod / durum / not / şerh. */
exports.YUKUMLULUK_ISARET_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
];
// ── Alan sözlüğü (yetki DEĞİL — ekran süzgeç yazmaz, buradan okur) ──────────
/** PTW onay zinciri basamağı olabilecek şapkalar — izleyici · temsilci · çalışan (+ temsilci fonksiyonu) dışarıda. */
exports.ZINCIR_BASAMAK_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'area_supervisor',
    'physician',
    'ysp',
];
/** Yeni zincirin ilk basamağının varsayılan şapkası (onaylayan alanın sorumlusudur). */
exports.ZINCIR_VARSAYILAN_BASAMAK_SAPKASI = 'area_supervisor';
/** "Basamak ekle" ile gelen satırın varsayılan şapkası. */
exports.ZINCIR_EK_BASAMAK_SAPKASI = 'isg_specialist';
/** Elle verilebilen şapkalar — `employee_rep` görevlendirmeden türetilir (5½ / B1; `POST role-assignments` 422). */
exports.ELLE_VERILEBILEN_SAPKALAR = shared_types_1.ROLE_TYPES.filter((sapka) => sapka !== 'employee_rep');
/** Ana kabuk yerine PORTAL kabuğu açan şapkalar (§18.2 — temsilci ana uygulamayı görmez). */
exports.PORTAL_SAPKALARI = ['contractor_rep'];
/** Guard'ın genel salt-okunur kuralı (§2.14) — GET/HEAD dışı her istek 403. */
exports.SALT_OKUNUR_SAPKALAR = ['viewer'];
//# sourceMappingURL=modul-rolleri.js.map